import { ReactNode } from 'react';
import { Box } from '@mui/material';

/*
*   Тело приложения
*/

export type IBody = {
    children?: ReactNode,
}

export default function Body({ children }: IBody) {

    return (
        <Box
            component='main'
            sx={{
                flexGrow: 1,
                padding: '88px 24px 24px 24px',
                minHeight: '100vh',
                maxWidth: '100%',
                overflow: 'hidden',
            }}
        >
            {children}
        </Box>
    );
}; 